// import { Footer } from "../../footer/Footer";
import { Box, Flex, useDimensions } from "@chakra-ui/react";
import { SideNavHeader } from "../../header/SideNavHeader";
import { useEffect, useRef } from "react";
import { sideNavBodyDimensionsVar } from "../../../lib/cache";

interface SideNavBodyProps {
  pageTitle?: string;
}

export const SideNavBody: React.FC<SideNavBodyProps> = ({
  pageTitle = "Publisher",
  children,
}) => {
  const sideNavBodyRef = useRef(null);
  const dimensions = useDimensions(sideNavBodyRef, true);
  useEffect(() => {
    sideNavBodyDimensionsVar(dimensions);
  }, [dimensions]);

  return (
    <Flex
      ref={sideNavBodyRef}
      width={"100%"}
      direction={"column"}
      overflowY={"scroll"}
      overflowX={"hidden"}
    >
      <SideNavHeader pageTitle={pageTitle} />
      <Box
        // flexGrow={1}
        mx={"auto"}
        w={"100%"}
        px={[6, null, null, null, 6]}
        mb={10}
      >
        <Box w={"100%"}>{children}</Box>
      </Box>
      {/* <Footer /> */}
    </Flex>
  );
};
